import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AccountRecord } from '@tassat/fred-definitions';
import React from 'react';

interface WalletNameCellRendererProps {
    value: { AccountName: string } | string;
    data: AccountRecord;
    nestedEntity?: string;
}

const muiStyles = makeStyles({
    root: {
        height: '100%',
        whiteSpace: 'normal' as const
    },
    text: {
        width: '100%',
        textOverflow: 'ellipsis' as const,
        whiteSpace: 'nowrap' as const,
        overflow: 'hidden' as const,
        lineHeight: '18px',
        color: '#375073',
        size: '16px',
        fontWeight: 700
    }
});

const WalletNameCellRenderer = (props: WalletNameCellRendererProps) => {
    const {
        value,
        data,
        nestedEntity
    } = props;

    const classes = muiStyles(props);
    const accountObject = nestedEntity ? data[nestedEntity] : typeof value !== 'string' && value.AccountName ? value : data;

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            {value === '-' ?
                <span data-testid='account-name'>{value}</span>
                : (
                    <>
                        <span
                            className={classes.text}
                            data-testid='account-name'
                        >{accountObject.AccountName}
                        </span>
                    </>
                )}
        </Grid>
    );
};

export default WalletNameCellRenderer;